import { useContext, useMemo } from 'react'
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { PersonaNavigation } from '../../../StateManagment/PersonaNavigation'
import computeGoalsSummary from '../../../helpers/goalsHelpers/computeGoalsSummary'
import { goalTitle } from '../../../helpers/goalsHelpers/personaGoalFields'
import useEffectNameById from '../../../hooks/personas/useEffectNameById'
import { goalStatus, goalStatusLabel } from '../../../helpers/goalsHelpers/personaGoalStatus'

const GoalsCard = () => {
    const personaId = Location()[3]
    const [, setPersonaNavigation] = useContext(PersonaNavigation)

    const goals = useFirestoreGeneralOrderBy(
        'PersonaGoals',
        'PersonaID',
        personaId || '',
        'Position',
        'asc'
    )

    const effectNameById = useEffectNameById()

    const summary = useMemo(() => computeGoalsSummary(goals), [goals])
    const recent = useMemo(
        () => (Array.isArray(goals) ? goals.slice(0, 3) : []),
        [goals]
    )

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Doelen</h3>
                <div className="goals-card-summary">
                    <span className="goals-card-summary-label">
                        {summary.reached} van {summary.total} bereikt
                    </span>
                    <div className="goals-card-progress">
                        <div
                            className="goals-card-progress-fill"
                            style={{ width: `${summary.percent}%` }}
                        />
                    </div>
                </div>
                {recent.length === 0 ? (
                    <p className="adress-dashboard-empty">Nog geen doelen.</p>
                ) : (
                    <ul className="adress-dashboard-list">
                        {recent.map(goal => {
                            const status = goalStatus(goal)
                            return (
                                <li key={goal.ID} className="adress-dashboard-list-row goals-card-row">
                                    <span className="adress-dashboard-list-title">
                                        {/* Zolang de effectnamen laden, nog niets beweren. */}
                                        {goalTitle(goal, effectNameById || {}) || (effectNameById ? '(zonder titel)' : '')}
                                    </span>
                                    <span className={`goals-card-status-pill goals-card-status-pill--${status}`}>
                                        {goalStatusLabel(goal)}
                                    </span>
                                </li>
                            )
                        })}
                    </ul>
                )}
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setPersonaNavigation('goals')}
                >
                    Bekijk alle doelen →
                </button>
            </div>
        </div>
    )
}

export default GoalsCard
